import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import Dashboard from "../../containers/Dashboard";
import Creditors from "../../containers/Creditors";
import AccountSetting from "../../containers/AccountSetting";
import Catalog from "../../containers/Catalog";
import OrderDetail from "../../containers/OrderDetail";
import CatalogNew from "../../containers/CatalogNew";
import NavigationCard from "../../components/navigationCard";
import MyOrders from "../../containers/MyOrders";
import Address from "../../containers/Address";
import PaymentSettings from "../../containers/PaymentSettings";
import Rmx from "../../containers/Rmx";
import StoreDown from "../../containers/SignUp/storedown";

class AuthRoutes extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      collapsedRight: true,
      collapsedLeft: false,
      ScreenWidth: window.innerWidth,
    };

    this.handleWidthChange = this.handleWidthChange.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      //this.props.redirect(this.props.location.pathname);
    }
    window.addEventListener("resize", this.handleWidthChange);
  }

  componentDidMount() {
    //this.props.setHistory(this.props.history);
    //this.props.redirect(this.props.location.pathname);
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.handleWidthChange);
  }
  handleWidthChange = () => {
    this.setState({
      ScreenWidth: window.innerWidth,
    });
  };
  toggleCollapsed = (type) => {
    this.setState({
      [type]: !this.state[type],
    });
  };

  render() {
    return (
      
      <NavigationCard {...this.props}>
          <Switch>
          <Route exact path="/dashboard" component={Dashboard} />
          <Route exact path="/address" component={Address} />
          <Route exact path="/order" component={MyOrders} />
          <Route exact path="/payment" component={PaymentSettings} />
          <Route exact path="/creditors" component={Creditors} />
          <Route exact path="/catalog/new" component={CatalogNew} />
          <Route exact path="/accounts" component={AccountSetting} />
          <Route exact path="/order/:id" component={OrderDetail} />
          <Route exact path="*" render={() => <Redirect to="/dashboard" />} />
      </Switch>
        </NavigationCard>
    );
  }
}

//Shell.contextType = ThemeContext;

export default connect(
  (state) => ({ storeState: state }),
  (dispatch) => ({})
)(AuthRoutes);
